import { render, staticRenderFns } from "./Access_Control.vue?vue&type=template&id=c54adff6&"
import script from "./Access_Control.vue?vue&type=script&lang=js&"
export * from "./Access_Control.vue?vue&type=script&lang=js&"
import style0 from "./Access_Control.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports